document.addEventListener('DOMContentLoaded', function() {
  
function initializeSection(sectionId, productVariants, productId){
    const section = document.querySelector(`#MainProduct-${sectionId}`);
    if (!section) return;
  
function getSelectedVariantId() {
  let selectedOptions = [];
  
  // Loop through the possible options (option1, option2, option3, etc.)
  for (let i = 1; i <= 3; i++) {
    let selectedOption = section.querySelector(`variant-selects .fieldset-${i} input[type="radio"]:checked`);
    selectedOptions.push(selectedOption ? selectedOption.value : null);
  }

  // Find the variant that matches the selected options
  let selectedVariant = productVariants.find(function(variant) {
    return variant.option1 === selectedOptions[0] &&
           variant.option2 === selectedOptions[1] &&
           variant.option3 === selectedOptions[2] &&
           variant.available;
  });

  // If no available variant is found, find the unavailable one
  if (!selectedVariant) {
    selectedVariant = productVariants.find(function(variant) {
      return variant.option1 === selectedOptions[0] &&
             variant.option2 === selectedOptions[1] &&
             variant.option3 === selectedOptions[2] &&
             !variant.available;
    });
  }
  // section.querySelector('.main-parent').getAttribute('url');
  return selectedVariant ? selectedVariant.id : null;
}

function updateOptionAvailability() {
  // Get all selected options
  let selectedOptions = [];
  for (let i = 1; i <= 3; i++) {
    let selectedOption = document.querySelector(`variant-selects .fieldset-${i} input[type="radio"]:checked`);
    selectedOptions.push(selectedOption ? selectedOption.value : null);
  }

  // Clear disabled class from all options initially
  section.querySelectorAll('.option-parent').forEach(function(optionParent) {
    optionParent.querySelectorAll('input[type="radio"]').forEach(function(radio) {
      radio.classList.remove('disabled');
    });
  });

  // Disable and enable options based on selected options
  productVariants.forEach(function(variant) {
    if (variant.available) {
      // Loop through options to match the variant
      selectedOptions.forEach(function(selectedOptionValue, index) {
        if (selectedOptionValue && variant[`option${index + 1}`] === selectedOptionValue) {
          enableOptions(index + 2, variant[`option${index + 2}`]); // Enable the next option based on current selection
        }
      });
    }
  });

  // Now check and disable any unavailable options
  disableUnavailableOptions();
}

function disableUnavailableOptions() {
  // Get all selected options dynamically
  let selectedOptions = [];
  for (let i = 1; i <= 3; i++) {
    let selectedOption = document.querySelector(`variant-selects .fieldset-${i} input[type="radio"]:checked`);
    selectedOptions.push(selectedOption ? selectedOption.value : null);
  }

  // Count how many option fields exist
  const totalOptionFields = document.querySelectorAll('variant-selects fieldset').length;

  // Disable options based on availability and selection conditions
  section.querySelectorAll('fieldset').forEach(function(optionParent) {
    const optionPosition = parseInt(optionParent.getAttribute('data-option-position'));
    const optionValues = optionParent.querySelectorAll('input[type="radio"]');

    // Skip logic based on required previous selections
    if (
      (optionPosition === 2 && !selectedOptions[0]) || // Option 2 requires Option 1
      (optionPosition === 3 && (!selectedOptions[0] || !selectedOptions[1])) // Option 3 requires Option 1 and 2
    ) {
      return;
    }

    optionValues.forEach(function(radio) {
      const value = radio.value;
      let isAvailable = false;

      // Check if the current option combination is available in any variant
      productVariants.forEach(function(variant) {
        if (!variant.available) return;

        if (optionPosition === 1 && variant.option1 === value) {
          isAvailable = true;
        }
        if (optionPosition === 2 &&
            variant.option1 === selectedOptions[0] &&
            variant.option2 === value) {
          isAvailable = true;
        }
        if (optionPosition === 3 &&
            variant.option1 === selectedOptions[0] &&
            variant.option2 === selectedOptions[1] &&
            variant.option3 === value) {
          isAvailable = true;
        }
      });

      // Enable or disable the radio button
      if (!isAvailable) {
        radio.classList.add('disabled');
      } else {
        radio.classList.remove('disabled');
      }
    });
  });
}


function formatPrice(priceInCents, sectionId) {
  // Get the currency from the section's data attribute
  var section = document.querySelector(`#${sectionId}`);
  var currency = section ? section.getAttribute('data-currency') : 'AED'; // Fallback to 'USD' if currency attribute is not found

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency: currency,
  });

  return formatter.format(priceInCents / 100); // Shopify stores prices in cents, so we divide by 100
}

function updatePrice() {
  var selectedVariantId = getSelectedVariantId();

  if (selectedVariantId) {
    var selectedVariant = productVariants.find(function(variant) {
      return variant.id == selectedVariantId;
    });

    if (selectedVariant) {
      toggleLoadingState(true);
      const baseUrl = window.location.pathname;
      const newUrl = `${window.shopUrl}${baseUrl}${selectedVariantId ? `?variant=${selectedVariantId}` : ''}`;
      console.log(newUrl,'new rullllllllll');

      // Fetch updated product section
      fetch(`${baseUrl}?variant=${selectedVariantId}&section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Replace price container
          const newPriceContainer = doc.querySelector(`#price-${sectionId}`);
          const currentPriceContainer = section.querySelector(`#price-${sectionId}`);
          if (newPriceContainer && currentPriceContainer) {
            currentPriceContainer.innerHTML = newPriceContainer.innerHTML;
          }
          toggleLoadingState(false);
        })
        .catch(error => {
          console.error('Failed to fetch updated price:', error);
        });
    }
  }
}


function enableOptions(optionPosition, optionValue) {
  console.log(optionPosition, 'option position')
  document.querySelectorAll(`variant-selects .fieldset-${optionPosition} input[type="radio"]`).forEach(function(radio) {
    if (radio.value === optionValue) {
      radio.classList.remove('disabled');
    }
  });
}


 function updateFormVarId(variantId) {
        section.querySelectorAll(
          `#product-form-${sectionId}, #product-form-installment-${sectionId}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

const buttonParent = section.querySelector('.product-form__submit');
const loader = buttonParent.querySelector('.loading__spinner');
const button = buttonParent.querySelector('span');


function toggleLoadingState(isLoading) {

  if (!buttonParent || !button) return;

  if (isLoading) {
    buttonParent.classList.add('is-loading');
    loader.classList.remove('hidden');
  } else {
    buttonParent.classList.remove('is-loading');
     loader.classList.add('hidden');
  }
}

// Function to check if all option fieldsets have one selected input
function allOptionsSelected() {
  const fieldsets = section.querySelectorAll('variant-selects fieldset');
  return Array.from(fieldsets).every(fieldset => 
    fieldset.querySelector('input[type="radio"]:checked')
  );
}

// Function to update the button state
function updateButtonState(variantId) {
  if (!allOptionsSelected()) {
    buttonParent.setAttribute('disabled', 'disabled');
    return;
  }

  if (!variantId) {
    buttonParent.setAttribute('disabled', 'disabled');
    button.innerText = window.variantStrings.unavailable;
  } else {
    updateFormVarId(variantId);
    const selectedVariant = productVariants.find(variant => variant.id === variantId);

    if (selectedVariant && !selectedVariant.available) {
      buttonParent.setAttribute('disabled', 'disabled');
      button.innerText = window.variantStrings.soldOut;
    } else {
      buttonParent.removeAttribute('disabled');
      button.innerText = window.variantStrings.addToCart;
    }
  }
}
function updateSelectedOptionLabels() {
  const fieldsets = section.querySelectorAll('variant-selects fieldset');

  fieldsets.forEach(fieldset => {
    const input = fieldset.querySelector('input[type="radio"]:checked');
    if(input){
      const selectedValue = input.value;
      const selectedSpan = fieldset.querySelector('span[selected]');
      console.log(selectedSpan, 'selected spannnnnn');
  
      if (selectedSpan) {
          selectedSpan.innerText = selectedValue;
      }
    }
  });
}


// Attach change listeners
section.querySelectorAll('variant-selects fieldset input[type="radio"]').forEach(function (radio) {
  radio.addEventListener('change', function () {
    const onevariantId = getSelectedVariantId();
    console.log(onevariantId, 'this is variantId');
    updateSelectedOptionLabels();
    updateOptionAvailability();
    updatePrice();
    updateButtonState(onevariantId);
  });
});



// updateOptionAvailability();
}




  
const sections = document.querySelectorAll('[data-section-new]');
  sections.forEach(section => {
    let sectionId = section.dataset.section;
    let productId = section.dataset.productId;
    const ProductJson = section.querySelector('script[data-product-variants]');
    const productData = JSON.parse(ProductJson.textContent || ProductJson.innerText);
    console.log(productData,'jason data')
    initializeSection(sectionId, productData, productId);
  });
    });